module.exports = __webpack_public_path__ + "img/back-top.c5e7bfb1.png";